"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.templatesV1 = exports.getAllV1Templates = exports.getOneTemplate = void 0;
const createApi_1 = require("../../helpers/createApi");
// V1
const getOneTemplate = (caller) => async ({ accountId, templateId }) => {
    const template = await caller(`/accounts/${accountId}/templates/${templateId}`).get();
    return {
        ...template,
        audience_data: JSON.parse(template.audience_data),
    };
};
exports.getOneTemplate = getOneTemplate;
const getAllV1Templates = (caller) => async (accountId) => {
    const templates = await caller(`/accounts/${accountId}/templates`).get();
    return templates.map((template) => ({
        ...template,
        audience_data: JSON.parse(template.audience_data),
    }));
};
exports.getAllV1Templates = getAllV1Templates;
exports.templatesV1 = (0, createApi_1.createAPIFactory)({
    get: exports.getOneTemplate,
    list: exports.getAllV1Templates,
});
//# sourceMappingURL=api.js.map